class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => this.onChange(event), ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const target = document.querySelector(selector);
            const source = html.querySelector(selector);
            if (target && source) target.replaceWith(source);
          }
        })
        .catch(console.error);
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          setTimeout(() => document.dispatchEvent(new Event('cart:updated')), 300);
        })
        .catch(console.error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

updateQuantity(line, quantity, event, name, variantId) {
  this.enableLoading(line);

  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((s) => s.section),
    sections_url: window.location.pathname,
  });

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
    .then((res) => res.text())
    .then((state) => {
      const parsed = JSON.parse(state);
      if (parsed.errors) return;


  // 🧠 If no items left, reload to show empty cart message
  if (parsed.item_count === 0) {
    window.location.reload();
    return;
  }

      this.classList.toggle('is-empty', parsed.item_count === 0);

      // ✅ SAFE LOOP – skip sections that don’t exist
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container || !parsed.sections[section.section]) return; // skip missing
        const sourceHTML = this.getSectionInnerHTML(parsed.sections[section.section], section.selector);
        const target = container.querySelector(section.selector) || container;
        if (target) target.innerHTML = sourceHTML;
      });

      // ✅ Trigger free shipping update after DOM refresh
      setTimeout(() => document.dispatchEvent(new Event('cart:updated')), 300);
    })
    .catch(console.error)
    .finally(() => this.disableLoading(line));
}


  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const main = document.getElementById('main-cart-items');
    if (main) main.classList.add('cart__items--disabled');
  }

  disableLoading(line) {
    const main = document.getElementById('main-cart-items');
    if (main) main.classList.remove('cart__items--disabled');
  }
}
customElements.define('cart-items', CartItems);

// Keep note support
if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function refreshFreeShippingBar() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const bar = document.getElementById('free-shipping-bar');
      const text = document.getElementById('free-shipping-text');
      const cartCounter = document.querySelector('.cart_counter');
      const shippingText = document.querySelector('.show_text_shipping');

      const threshold = parseInt(bar?.dataset?.threshold || 0, 10);
      const total = cart.total_price;

      /* --- 🧮 1. Update cart counter with total quantity --- */
      if (cartCounter) {
        const count = cart.item_count; // total quantity (not distinct items)
        const label = count === 1 ? 'item' : 'items';
        cartCounter.textContent = `${count} ${label}`;
      }

      /* --- 🚚 2. Update free shipping text and show_text_shipping --- */
      if (bar && text) {
        if (!threshold || threshold <= 0) {
          text.textContent = 'Shipping calculated at checkout.';
          if (shippingText) shippingText.textContent = 'Calculated at checkout';
          return;
        }

        if (total >= threshold) {
          text.textContent = '🎉 You’ve unlocked Free Shipping!';
          if (shippingText) shippingText.textContent = 'Free';
        } else {
          const remaining = (threshold - total) / 100;
          text.textContent = `🚚 Only $${remaining.toFixed(2)} away from free shipping!`;
          if (shippingText) shippingText.textContent = 'Calculated at checkout';
        }
      }

      console.log('🟢 Free shipping + counter updated:', {
        total_price: total,
        item_count: cart.item_count,
      });
    })
    .catch((err) => console.warn('Global free shipping bar update failed:', err));
}

// Update when Shopify re-renders cart or on AJAX changes
document.addEventListener('DOMContentLoaded', refreshFreeShippingBar);
document.addEventListener('cart:updated', refreshFreeShippingBar);
document.addEventListener('shopify:section:load', refreshFreeShippingBar);
